<template>
    <div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th> # </th>
                    <th>{{ $t('Name') }} </th>
                    <th>{{ $t('Assign to') }} </th>
                    <th>{{ $t('Due date') }} </th>
                    <th>{{ $t('Priority') }} </th>
                    <th>{{ $t('Weight') }} </th>
                    <th>{{ $t('Status') }} </th>
                    <th>{{ $t('Created at') }} </th>
                </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item, index) in project.tasks"
                        :key="`task-${index}`"
                        class="py-3"
                    >
                        <td>{{ index + 1 }}</td>
                        <td>
                            <router-link :to="{ name: 'my-workings.detail', params: {id:item.id } }" target="_blank">{{  item.name }}</router-link>
                        </td>
                        <td>{{ item.user.name || '---' }}</td>
                        <td>{{ dateFormat(item.due_date) }}</td>
                        <td>
                            <div :class="`color-priority priority-${item.priority}`">{{ __attr(`priority.${item.priority}`) }}</div>
                        </td>
                        <td>{{ item.weight }}</td>
                        <td>
                            <div :class="`color-status ${item.status}`">{{ __attr(item.status) }}</div>
                        </td>
                        <td>{{ utcToLocalDateTimeLess(item.created_at) }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import { dateFormat, utcToLocalDateTimeLess } from '@utils'

export default {
  name: 'ShowAssignment',
  props: [
    'project'
  ],
  methods: {
    dateFormat,
    utcToLocalDateTimeLess
  }
}
</script>
